import * as numeral from 'numeral';
import { InputModel } from '../components/SectionWrapper/SectionWrapper';
import { Country } from '../content/content';
import { YesOrNo, PoundOrPercent } from '../interfaces';

const RunPAT = require('../calculator/ctcModeller');
require('numeral/locales/en-gb');

numeral.locale('en-gb');
numeral.defaultFormat('$0,0.00');

export interface CTCOutputModel {
  ActualCostToYou: number;
  Annuity: number;
  FundExhausionAge: number;
  ProjectedFund_Monetary: number; // eslint-disable-line
  ProjectedFund_Real: number; // eslint-disable-line
  ResidualFundAfterTax: number;
  ResidualFundBeforeTax: number;
  TFC: number;
  TaxDue: number;
  TotalContribution: number;
  TotalEmployeeContributions: number;
  TotalEmployerContributions: number;
  TotalNetContributions: number;
  TotalPotentialGrowth: number;
  TotalTaxRelief: number;
  growthLevel: string;
}

export const formatModel = (model: InputModel) =>
  Object.assign(
    {
      Age: Number(model.age),
      Location:
        model.scottishTaxPayer === YesOrNo.Yes ? Country.Scotland : Country.UK,
      PRA: Number(model.withdrawalAge),
      FundValue: Number(model.totalValue),
      AMC: 0.75,
      Growth: 5,
      AnnualEarnings: Number(model.income),
      AnnualEarningsIncrease: 3.5,
      EmployeeContType:
        model.employeeContributionType === PoundOrPercent.Percent ? 'P' : 'A',
      EmployeeCont: model.employeeContribution,
      EmployerContType:
        model.employerContributionType === PoundOrPercent.Percent ? 'P' : 'A',
      EmployerCont: model.employerContribution,
      SalarySacrificeInd: YesOrNo.No,
      AnnualIncomeRequired: Number(model.neededMoney),
      AnnualIncomeReqIncrease: 2,
      AnnuityGteeYears: 0,
      AnnuityEscalation: 0,
      SpousePercentage: 0,
    },
  );

export const runModeller = (model: InputModel) => RunPAT(formatModel(model), true);

export const getResults = (results: CTCOutputModel[], model: InputModel) =>
  results;

export const calculate = (model: InputModel) => getResults(runModeller(model), model);




// WEBPACK FOOTER //
// ./src/utilities/calculator.ts